<template>
  <div class="fd-wwnry fd-xwzx" style="min-height:70vh">
    <el-row :gutter="16">
      <!-- <el-col :span="4">
        <leftMenu :path='path' :menuList="menuList.length > 0 ? menuList : homeMenuList"></leftMenu>
      </el-col> -->
      <el-col :span="24" style="min-height:800px">
        <div class="fd-content-bg" style="height:100%">
          <h3 style="margin-bottom:14px;font-size:28px;font-family: SimHei,serif !important;">
            {{ news.title }}
          </h3>
          <h3 style="margin-bottom:14px;font-family: SimHei,serif !important;">
            {{ news.subtitle }}
          </h3>
          <div>
            <span class="author" v-if="news.f22 != null">作者:{{ news.f22 }} | </span>
            <span class="author" v-if="news.source != null">来源:{{ news.source }} | </span>
            <span class="author" v-if="news.publishDate != null">时间:{{ news.publishDate }}</span>
            <!-- <span class="author" v-if="news.sumHits != null">点击量：{{ news.sumHits }}</span> -->
          </div>
          <br>
          <!-- 需求要求：富文本中的字体全部统一为宋体 -->
          <div v-html="news.content" style="font-family: SimSun,serif !important;text-align:left;" class="fd-content">
          </div>
          <br>
          <div class="fd-row" v-if="news.sign==='1'">
            <div class="fd-pdf-title">附件下载:</div>
            <div class="fd-row fd-flex-wrap" >
              <!-- 多个的话循环下方的div就行了 -->
              <div class="fd-pdf-box" @click="downloadFile(item)" v-for="(item,index) in fileList" :key="item">
                <span class="fd-pdf-img"></span>
                <span :title="item.fileName" >{{item.fileName}}</span>
                <span class="fd-down-img"></span>
              </div>
            </div>
          </div>
          <div class="pdf" v-show="fileType === 'pdf'">
            <pdf :src="pdfUrl">
            </pdf>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
var moment = require('moment');
import { saveAs } from 'file-saver';
import pdf from 'vue-pdf';
import leftMenu from '../components/leftMenu.vue';
export default {
  components: { pdf, leftMenu },
  data() {
    return {
      flag: 0,
      year: '',
      day: '',
      time: '',
      news: {
        title: '',
        source: '',
        content: '',
        publishDate: '',
      },
      ysSign: 0,
      aaa: 1,
      pdfUrl: '',
      crumbs: [
        {
          name: '学院概况',
          id: 'SYZT_XYGK',
          path: '/xygk/xyjj',
          _id: 'SYZT_XYGK_XYJJ',
        },
        { name: '学院简介', id: 'SYZT_XYGK_XYJJ', path: '/xygk/xyjj' },
        { name: '社院历史', id: 'SYZT_XYGK_SYLS', path: '/xygk/syls' },
        { name: '现任领导', id: 'SYZT_XYGK_XRLD', path: '/xygk/xrld' },
        { name: '学院风光', id: 'SYZT_XYGK_XYFG', path: '/xygk/xyfg' },
        { name: '地理位置', id: 'SYZT_XYGK_DLWZ', path: '/xygk/dlwz' },
        {
          name: '新闻中心',
          id: 'SYZT_XWZX',
          path: '/xwzx/tzyw',
          _id: 'SYZT_XWZX_TZYW',
        },
        { name: '新闻时讯', id: 'SYZT_XWZX_TZYW', path: '/xwzx/tzyw' },
        { name: '公示公告', id: 'SYZT_XWZX_TZGG', path: '/xwzx/tzgg' },
        { name: '市县新闻', id: 'SYZT_XWZX_SXXW', path: '/xwzx/sxxw' },
        { name: '本院新闻', id: 'SYZT_XWZX_SYXW', path: '/xwzx/syxw' },
        {
          name: '教学培训',
          id: 'SYZT_JXPX',
          path: '/jxpx/jxxx',
          _id: 'SYZT_JXPX_JXXX',
        },
        { name: '教学培训', id: 'SYZT_JXPX_JXXX', path: '/jxpx/jxxx' },
        { name: '教学研究', id: 'SYZT_JXPX_JXYJ', path: '/jxpx/jxyj' },
        { name: '专职教师', id: 'SYZT_JXPX_ZZJS', path: '/jxpx/zzjs' },
        { name: '兼职教师', id: 'SYZT_JXPX_JZJS', path: '/jxpx/jzjs' },
        { name: '教务管理', id: 'SYZT_JXPX_JWGL', path: '/jxpx/jwgl' },
        { name: '对外培训', id: 'SYZT_JXPX_DWPX', path: '/jxpx/dwpx' },
        {
          name: '科研智库',
          id: 'SYZT_KYZK',
          path: '/kyzk/kydt',
          _id: 'SYZT_KYZK_KYDT',
        },
        { name: '科研成果', id: 'SYZT_KYZK_KYCG', path: '/kyzk/kycg' },
        { name: '科研管理', id: 'SYZT_KYZK_KYGL', path: '/kyzk/kygl' },
        { name: '科研动态', id: 'SYZT_KYZK_KYDT', path: '/kyzk/kydt' },
        {
          name: '统战理论',
          id: 'SYZT_TZLL',
          path: '/tzll/jdls',
          _id: 'SYZT_TZLL_JDLS',
        },
        { name: '统战文选', id: 'SYZT_TZLL_TZWX', path: '/tzll/tzwx' },
        { name: '统战政策', id: 'SYZT_TZLL_TZZC', path: '/tzll/tzzc' },
        { name: '经典论述', id: 'SYZT_TZLL_JDLS', path: '/tzll/jdls' },
        {
          name: '文化交流',
          id: 'SYZT_WHJL',
          path: '/whjl/xyjj',
          _id: 'SYZT_WHJL_XYJJ',
        },
        { name: '中华文化', id: 'SYZT_WHJL_ZHWH', path: '/whjl/zhwh' },
        { name: '浙江文化', id: 'SYZT_WHJL_ZJWH', path: '/whjl/zjwh' },
        { name: '学院动态', id: 'SYZT_WHJL_XYDT', path: '/whjl/xydt' },
        { name: '学院简介', id: 'SYZT_WHJL_XYJJ', path: '/whjl/xyjj' },
        { name: '专题', id: 'SYZT_ZT', path: '/zt' },
        {
          name: '机关党建',
          id: 'SYZT_JGDJ',
          path: '/jgdj/djxw',
          _id: 'SYZT_JGDJ_DJXW',
        },
        { name: '党建新闻', id: 'SYZT_JGDJ_DJXW', path: '/jgdj/djxw' },
        { name: '预决算信息', id: 'yjsxxgk', path: '/yjs/yjsxx' },
        {
          name: '图书馆',
          id: 'SYZT_TSG',
          path: '/tsg/bygk',
          _id: 'SYZT_TSG_TSJS',
        },
        { name: '图书检索', id: 'SYZT_TSG_TSJS', path: '/tsg/tsjs' },
        { name: '数字资源', id: 'SYZT_TSG_SZZY', path: '/tsg/bygk' },
        { name: '本院概况', id: 'SYZT_TSG_BYGK', path: '/tsg/bygk' },
        {
          name: '参政党建设研究中心',
          id: 'SYZT_CZDJSYJZX',
          path: '/czdzx/zxgk',
          _id: 'SYZT_CZDJSYJZX_ZXGK',
        },
        { name: '中心概况', id: 'SYZT_CZDJSYJZX_ZXGK', path: '/czdzx/zxgk' },
        { name: '中心信息', id: 'SYZT_CZDJSYJZX_ZXXX', path: '/czdzx/zxxx' },
        {
          name: '参政党研究文献',
          id: 'SYZT_CZDJSYJZX_CZDWX',
          path: '/czdzx/czdwx',
        },
        { name: '其他研究资料', id: 'SYZT_CZDJSYJZX_YJZL', path: '/czdzx/yjzl' },
        { name: '案例库', id: 'SYZT_CZDJSYJZX_AJK', path: '/czdzx/ajk' },
        {
          name: '非公有制经济两个健康研究中心',
          id: 'SYZT_FGYZJJZX',
          path: '/fgyzjjzx/zxgk',
          _id: 'SYZT_FGYZJJZX_ZXGK',
        },
        { name: '中心概况', id: 'SYZT_FGYZJJZX_ZXGK', path: '/fgyzjjzx/zxgk' },
        { name: '中心信息', id: 'SYZT_FGYZJJZX_ZXXX', path: '/fgyzjjzx/zxxx' },
        { name: '研究资料', id: 'SYZT_FGYZJJZX_YJZL', path: '/fgyzjjzx/yjzl' },
        { name: '案例库', id: 'SYZT_FGYZJJZX_AJK', path: '/fgyzjjzx/ajk' },
        {
          name: '民族与宗教研究中心',
          id: 'SYZT_MZYZJYJZX',
          path: '/mzyzjzx/zxgk',
          _id: 'SYZT_MZYZJYJZX_ZXGK',
        },
        { name: '中心概况', id: 'SYZT_MZYZJYJZX_ZXGK', path: '/mzyzjzx/zxgk' },
        { name: '中心信息', id: 'SYZT_MZYZJYJZX_ZXXX', path: '/mzyzjzx/zxxx' },
        { name: '研究资料', id: 'SYZT_MZYZJYJZX_YJZL', path: '/mzyzjzx/yjzl' },
        { name: '案例库', id: 'SYZT_MZYZJYJZX_AJK', path: '/mzyzjzx/ajk' },
        {
          name: '中华文化研究中心',
          id: 'SYZT_ZHWHYJZX',
          path: '/zhwhzx/zxgk',
          _id: 'SYZT_ZHWHYJZX_ZXGK',
        },
        { name: '中心概况', id: 'SYZT_ZHWHYJZX_ZXGK', path: '/zhwhzx/zxgk' },
        { name: '中心信息', id: 'SYZT_ZHWHYJZX_ZXXX', path: '/zhwhzx/zxxx' },
        { name: '研究资料', id: 'SYZT_ZHWHYJZX_YJZL', path: '/zhwhzx/yjzl' },
        { name: '案例库', id: 'SYZT_ZHWHYJZX_AJK', path: '/zhwhzx/ajk' },
      ],
      columnCode: '',
      secondCrumbs: '',
      currentCrumbs: '',
      currentId: '',
      secondCrumbsId: '',
      menuList: [],
      path: '',
      homeMenuList: [{ menuName: '首页', menuUrl: '/portal' }],
      fileList:[]
    };
  },
  methods: {
    getTime() {
      setInterval(() => {
        // this.year=moment().format('YYYY');
        // this.day=moment().format("MMM Do ");
        this.time = moment().format('HH:mm');
      }, 1000);
      // console.log(this.year,this.day,this.time)
    },
    formatTime() {
      moment.locale('zh-cn', {
        months:
          '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_',
          ),
        monthsShort: '01_02_03-_04_05_06_07_08_09_10_11_12'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
          LT: 'HH:mm',
          LTS: 'HH:mm:ss',
          L: 'YYYY-MM-DD',
          LL: 'YYYY年MM月DD日',
          LLL: 'YYYY年MM月DD日Ah点mm分',
          LLLL: 'YYYY年MM月DD日ddddAh点mm分',
          l: 'YYYY-M-D',
          ll: 'YYYY年M月D日',
          lll: 'YYYY年M月D日 HH:mm',
          llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
          if (hour === 12) {
            hour = 0;
          }
          if (
            meridiem === '凌晨' ||
            meridiem === '早上' ||
            meridiem === '上午'
          ) {
            return hour;
          } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
          } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
          }
        },
        meridiem: function (hour, minute, isLower) {
          const hm = hour * 100 + minute;
          if (hm < 600) {
            return '凌晨';
          } else if (hm < 900) {
            return '早上';
          } else if (hm < 1130) {
            return '上午';
          } else if (hm < 1230) {
            return '中午';
          } else if (hm < 1800) {
            return '下午';
          } else {
            return '晚上';
          }
        },
        calendar: {
          sameDay: '[今天]LT',
          nextDay: '[明天]LT',
          nextWeek: '[下]ddddLT',
          lastDay: '[昨天]LT',
          lastWeek: '[上]ddddLT',
          sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
          switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
              return '-' + number;
            case 'M':
              return number;
            case 'w':
            case 'W':
              return number + '周';
            default:
              return number;
          }
        },
        relativeTime: {
          future: '%s内',
          past: '%s前',
          s: '几秒',
          ss: '%d秒',
          m: '1分钟',
          mm: '%d分钟',
          h: '1小时',
          hh: '%d小时',
          d: '1天',
          dd: '%d天',
          M: '1个月',
          MM: '%d个月',
          y: '1年',
          yy: '%d年',
        },
        week: {
          // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
          dow: 1, // Monday is the first day of the week.
          doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
      });
    },

    /**
     * 用于获取新闻详情
     * @param ： id 新闻唯一标识
     * @author ： 吴俊迪 wujundi
     */
    getNewsDetail(id, flag) {
      let _this = this;
      _this.axios.get(
        `/api/vi/portal/xw/getNews/${id}/${flag}`,
        {},
        {},
        (res) => {
          if (res && res.status == 200) {
            console.log(res);
            _this.news = res.data;
            this.fileList  = res.data.fileInfo
            // _this.formattedDate();
            _this.columnCode = res.data.columnCode;
            _this.setCrumbs(res.data.columnCode);
          }
        },
      );
    },
    /**
     * 用于获取监督举报联系方式的详情
     * @param ： columnCode 栏目标号
     * @author ： 吴俊迪 wujundi
     */
    getContent() {
      let _this = this;
      const rangeType = {
        columnCode: _this.columnCode,
      };
      _this.axios.post(`/api/v1/portal/secondary/gd`, rangeType, {}, (resp) => {
        if (resp && resp.status === 200) {
          _this.news = resp.data[0];
          _this.formattedDate();
        }
      });
    },
    /**
     * 根据id 或 columnId 的非空情况来判断具体使用哪种查询
     * @author ： 吴俊迪 wujundi
     */
    getData() {
      let _this = this;
      let id = _this.$route.query.id;
      _this.columnCode = _this.$route.query.columnCode;
      _this.flag = _this.$route.query.flag;
      if (typeof _this.flag == 'undefined') {
        _this.flag = 0;
      }
      if (typeof id !== 'undefined') {
        _this.getNewsDetail(id, _this.flag);
      } else {
        _this.getContent();
      }
    },
    /**
     * 将日期转换为需求的格式
     */
    formattedDate() {
      let _this = this;
      _this.year = _this.news.publishDate.split('-')[0];
      _this.day =
        _this.news.publishDate.split('-')[1] +
        '-' +
        _this.news.publishDate.split('-')[2].split(' ')[0];
      let temp = _this.news.publishDate.split(' ')[1].split(':');
      _this.time = temp[0] + ':' + temp[1];
    },
    downloadFile(item) {
      const url =
        `/api/v1/files/${item.fileName}` +
        '?fid=' +
        item.attachmentId +
        '&chksum=' +
        item.checksum;
      window.open(url);
    },
  },
  created() {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.path = this.$route.query.path;
  },
  mounted() {
    // this.formatTime()
    // this.time=moment().format("HH:mm");
    // this.getTime()
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    this.getData();
    this.ysSign = this.$route.query.sign;
  },
};
</script>
<style>
.fd-content p img {
  margin: 15px auto !important;
  max-width: 100%;
  display: block;
}
.fd-content p,.fd-content p span,.fd-content p strong {
  word-break: break-all;
  /* margin: 15px auto !important; */
  text-indent: 2em;
  font-size: 16px !important;
  line-height: 30px !important;
  color: #000 !important;
  font-weight: 400 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}
.fd-content p strong span{
  font-weight: 700 !important;
}

.fd-content p span {
  font-size: 16px !important;
  color: #000 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}

.fd-content div {
  word-break: break-all;
  margin: 15px auto;
  text-indent: 2em;
  font-size: 16px !important;
  line-height: 30px !important;
  color: #000 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}

.fd-content div span {
  font-size: 16px !important;
  line-height: 30px !important;
  color: #000 !important;
  font-family: PingFang SC, Hiragino Sans GB, Microsoft YaHei UI,
    Microsoft YaHei, Source Han Sans CN, sans-serif !important;
}

.crumbs-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.crumbs-home {
  background: #ffffff;
  box-shadow: 0 0 4px 0 #c7e1ff;
  border-radius: 16px;
  width: 76px;
  height: 32px;
  line-height: 32px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.crumbs-home-icon-frame {
  width: 24px;
  height: 24px;
  border-radius: 24px;
  opacity: 1;
  background-image: linear-gradient(-63deg, #359eff 0%, #6eaeff 93%);
  float: left;
  line-height: 24px;
  margin: 4px;
}

.crumbs-home-icon {
  background: url('../assets/images/crumbs-home-icon.png') no-repeat;
  width: 16px;
  height: 16px;
  margin: 4px;
}

.crumbs-box {
  display: inline-block;
  text-align: center;
  margin: 5px auto;
  line-height: 36px;
}

.crumbs-current {
  float: left;
  opacity: 1;
  background-image: linear-gradient(-63deg, #359eff 0%, #6eaeff 93%);
  border-radius: 16px;
  box-shadow: 0 0 4px 0 #c7e1ff;
  border-radius: 16px;
  width: 76px;
  height: 32px;
  line-height: 32px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  cursor: pointer;
  margin: 4px;
}

.author {
  font-size: 14px;
}
.fd-row {
  display: flex;
}
.fd-flex-wrap {
  flex-wrap: wrap;
}
.fd-row span {
  display: inline-block;
  vertical-align: middle;
  font-family: Helvetica;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.75);
}
.fd-pdf-title {
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  font-weight: 600;
  margin-right: 15px;
  flex: 0 0 auto;
}
.fd-row span:nth-child(2) {
  flex: 1 1 auto;
  text-align: left;
  padding-left: 10px;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.fd-pdf-box {
  display: flex;
  padding: 21px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  margin: 0 10px 10px 0;
  width: 385px;
  align-items: center;
}
.fd-pdf-img {
  width: 24px;
  height: 30px;
  background: url('../assets/images/pdf.png') no-repeat;
  flex: 0 0 auto;
  cursor: pointer;
}
.fd-down-img {
  position: relative;
  width: 24px;
  height: 30px;
  background: #f6f8fa;
  border-radius: 4px;
  flex: 0 0 auto;
  cursor: pointer;
}
.fd-down-img::before {
  position: absolute;
  content: '';
  width: 11px;
  height: 13px;
  background: url('../assets/images/downLoad.png') no-repeat;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/page/wwnry.vue